import React from 'react';
import ridingEnvelopeImage from '../../../../assets/images/riding-envelope.png';

const EmptyState = React.memo(() => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '30px 0px',
    height: '100%',
    minHeight: '400px',
    overflowY: 'auto'
  }}>
    <div style={{
      width: '215px',
      height: '215px',
      marginBottom: '20px'
    }}>
      <img
        src={ridingEnvelopeImage}
        alt="Empty inbox"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
      />
    </div>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '8px',
      width: '544px',
      maxWidth: '100%'
    }}>
      <h3 style={{
        fontFamily: 'Poppins',
        fontWeight: '600',
        fontSize: '18px',
        lineHeight: '1.5em',
        letterSpacing: '0.25%',
        textAlign: 'center',
        color: '#344054',
        margin: '0',
        width: '551px',
        maxWidth: '100%'
      }}>
        Your inbox is currently empty.
      </h3>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        width: '555px',
        maxWidth: '100%'
      }}>
        <p style={{
          fontFamily: 'Poppins',
          fontWeight: '400',
          fontSize: '14px',
          lineHeight: '1.5em',
          textAlign: 'center',
          color: '#344054',
          margin: '0',
          width: '554px',
          maxWidth: '100%'
        }}>
          We&apos;ll let you know when a new message comes in.
        </p>
      </div>
    </div>
  </div>
));

EmptyState.displayName = 'EmptyState';

export default EmptyState;
